import React, { Component } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { uuid } from 'uuidv4';
import { withRouter } from 'react-router-dom';
import ProfileHeader from './ProfileHeader';
import AccountDisplay from './displays/AccountDisplay';
import FamilyDisplay from './displays/FamilyDisplay';
import AccountEditDisplay from './displays/AccountEditDisplay';
import FamilyEditDisplay from './displays/FamilyEditDisplay';
import PreferenceDisplay from './displays/PreferenceDisplay';
import PreferenceEditDisplay from './displays/PreferenceEditDisplay';
import ApiClient from '../../shared/ApiClient';
import PayMethods from '../payments/Components/PayMethods';
import { Grid } from '@material-ui/core';
import client from '../../shared/ApiClient';
import { consoleLogInDev } from 'shared';
import { UserContext } from 'UserContext';
import { trackEvent, PublicSessionEventType } from 'parent-portal/shared/PublicSessionTracking';
import { Environment, MixPanelKey } from 'environmentVariables';

var mixpanel = require('mixpanel-browser');
mixpanel.init(MixPanelKey);

const Section = styled.div`
    align-content: center;
    align-items: center;
    justify-content: center;
`;

const certificates = {
    CPR_CERTIFIED: 'CPR Certified',
    FIRST_AID_CERTIFIED: 'First Aid Certified',
    SLEEP_TRAINING_CERTIFIED: 'Sleep Training Certified',
    INFANT_CERTIFIED: 'Infant Certified',
};
const experiences = {
    AUTISM: 'Autism',
    ADHD: 'ADHD',
    LEARNING_DELAYS: 'Learning Delays (i.e. 504 plan/IEP)',
    ALLERGIES: 'Allergies',
    DEVELOPMENT_DELAYS: 'Development Delays',
    BRAIN_INJURY: 'Brain Injury',
    IMMUNOCOMPROMISED_PERSONS: 'Immunocompromised Persons',
};

class FamilyProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            family: {},
            address: {},
            families: [],
            kids: [
                {
                    id: 0,
                    name: '',
                    birthday: '',
                    parsedBirthday: '',
                    comments: '',
                    isName: true,
                    isBirthday: true,
                    type: 'Child',
                    newKid: false,
                },
            ],
            deletedKids: [],
            phoneNumbers: [],
            isZip: true,
            isCity: true,
            isState: true,
            isStreet: true,
            isFirstName: true,
            isLastName: true,
            isEmail: true,
            isPrimaryPhoneNumber: true,
            isSecondaryPhoneNumber: true,
            isBio: true,
            isBirthday: true,
            newKid: false,
            page: 0,
            gmapsLoaded: false,
            errorMessage: 'Please enter your phone number',
            firstName: '',
            lastName: '',
            city: '',
            state: '',
            street: '',
            zip: '',
            primaryPhoneNumber: '',
            parsedPrimaryNumber: '',
            secondaryPhoneNumber: '',
            parsedSecondaryNumber: '',
            email: '',
            bio: '',
            addedAt: '',
            userId: -1,
            familyId: -1,
            payments: [],
            paymentsLoadingId: null,
            profilePic: null,
            pictureDialogVisible: false,
            certificationPreferences: [],
            experiencePreferences: [],
        };
        this.kidsIndex = 0;
    }
    static contextType = UserContext;

    patchPreference = async () => {
        this.patchFamily();
        //goes back to previous page
        this.pageHandler(7);
    };

    initMap = () => {
        this.setState({
            gmapsLoaded: true,
        });
    };

    pageHandler(p) {
        this.setState({ page: p });
    }

    edit_account() {
        this.setState({ page: 3 });
        const { gmapsLoaded } = this.state;
        if (!gmapsLoaded) {
            window.initMap = this.initMap;
            const gmapScriptEl = document.createElement('script');
            gmapScriptEl.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDMFNVM0PCvBo1WejoyZM77_cZYgHuu48g&libraries=places&callback=initMap`;
            document.querySelector(`body`).insertAdjacentElement(`beforeend`, gmapScriptEl);
        }
    }

    edit_family() {
        const { kids } = this.state;
        for (let i = 0; i < kids.length; i++) {
            kids[i].isName = true;
            kids[i].isBirthday = true;
        }
        this.setState({ page: 4 });
    }

    deleteNumber = async () => {
        const { phoneNumbers } = this.state;

        const newArray = phoneNumbers;

        newArray.splice(1);

        await this.setState({ secondaryPhoneNumber: null });

        await this.setState({ phoneNumbers: newArray });

        this.patchUser();
    };

    onChangeText = async (name, e) => {
        const text = e.target.value;
        if (name === 'phone_number') {
            var match = text.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
            var cleaned = ('' + text).replace(/\D/g, '');
            match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                var number = ['(', match[2], ') ', match[3], ' - ', match[4]].join('');
                this.setState({ primaryPhoneNumber: number });
                return;
            }
            this.setState({ primaryPhoneNumber: text });
        } else if (name === 'secondary_phone_number') {
            match = text.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                number = ['(', match[2], ') ', match[3], ' - ', match[4]].join('');
                this.setState({ secondaryPhoneNumber: number });
                return;
            }
            this.setState({ secondaryPhoneNumber: text });
        } else {
            this.setState({ [name]: text });
        }
    };

    validatePhoneNumber(phoneNumber) {
        var letters = /^[A-Za-z]+$/;

        if (phoneNumber.length === 16 && !phoneNumber.match(letters)) {
            return true;
        }
        return false;
    }

    validateDate(date) {
        var valid = moment(date, 'YYYY-MM-DD').isValid();
        return valid;
    }

    patchFamily = async () => {
        const {
            primaryPhoneNumber,
            bio,
            addedAt,
            family,
            certificationPreferences,
            experiencePreferences,
        } = this.state;
        var parsed_date = moment(addedAt, 'MM/DD/YYYY hh:mm A').format('YYYY-MM-DD HH:mm:ss');
        var family_id = family.id;
        var parsedNumber =
            '+1' + primaryPhoneNumber.slice(1, 4) + primaryPhoneNumber.slice(6, 9) + primaryPhoneNumber.slice(12, 16);
        var new_family = {
            added_at: parsed_date,
            phone_number: parsedNumber,
            bio: bio,
            covid_exempt: false,
            certification_preferences: certificationPreferences,
            experience_preferences: experiencePreferences,
        };
        try {
            await client('api/families/' + family_id + '/', { body: new_family, method: 'PATCH' });

            mixpanel.track('Profile: Save Family', new_family);

            this.getFamily();
        } catch (error) {
            if (Environment !== 'production') {
                console.log(error);
            }
        }
    };

    deleteKids = async () => {
        const { deletedKids } = this.state;
        for (let i = 0; i < deletedKids.length; i++) {
            try {
                let res = await client('api/kids/' + deletedKids[i], { method: 'DELETE' });
                mixpanel.track('Profile: Delete Kid', { kid: deletedKids[i], status: res.status });
            } catch (error) {
                if (Environment !== 'production') {
                    console.log(error);
                }
            }
        }

        this.getKids();
    };

    postKids = async () => {
        const { kids, familyId } = this.state;

        for (let i = 0; i < kids.length; i++) {
            if (kids[i].newKid) {
                var kid = {
                    name: kids[i].name,
                    age: kids[i].age,
                    birthday: kids[i].birthday,
                    comments: kids[i].comments,
                    family: familyId,
                    present: true,
                    type: kids[i].type.toUpperCase(),
                };

                try {
                    await client('api/kids/', { body: kid });

                    mixpanel.track('Profile: Add Kid', { kid });
                    this.setState({ newKid: false });
                    kids[i].newKid = false;
                    this.getKids();
                } catch (error) {
                    if (Environment !== 'production') {
                        console.log(error);
                    }
                }
            }
        }
    };

    patchKids = async () => {
        const { kids, familyId } = this.state;
        for (let i = 0; i < kids.length; i++) {
            var kid = {
                name: kids[i].name,
                age: kids[i].age,
                birthday: kids[i].birthday,
                comments: kids[i].comments,
                family: familyId,
                present: true,
                type: kids[i].type.toUpperCase(),
            };

            try {
                await client('api/kids/' + kids[i].id + '/', {
                    method: 'PATCH',
                    body: kid,
                });
                mixpanel.track('Profile: Save Kid', { kid: kids[i] });
            } catch (error) {
                if (Environment !== 'production') {
                    console.log(error);
                }
            }
        }

        this.getKids();
    };

    patchAddress = async () => {
        const { street, city, state, zip, address } = this.state;
        var address_id = address.id;
        var user_id = address.user;
        var new_address = {
            street: street,
            state: state,
            city: city,
            zip_code: zip,
            user: user_id,
        };
        try {
            await client('api/addresses/' + address_id + '/', {
                method: 'PATCH',
                body: new_address,
            });
            mixpanel.track('Profile: Save Address', new_address);
            this.getAddresses();
            this.context.refreshUser();
        } catch (error) {
            if (Environment !== 'production') {
                console.log(error);
            }
        }
    };

    patchUser = async () => {
        //PATCH USER
        const { primaryPhoneNumber, firstName, lastName, secondaryPhoneNumber, user } = this.state;

        var id = user.id;
        var parsedNumber =
            '+1' + primaryPhoneNumber.slice(1, 4) + primaryPhoneNumber.slice(6, 9) + primaryPhoneNumber.slice(12, 16);
        //User object
        var new_user = {
            first_name: firstName,
            last_name: lastName,
            phone_number: parsedNumber,
            secondary_phone_number: null,
            is_active: true,
            staff: false,
            admin: false,
            is_superuser: false,
            rand_hex: uuid(),
        };
        if (secondaryPhoneNumber !== null) {
            var parsedSecondaryNumber =
                '+1' +
                secondaryPhoneNumber.slice(1, 4) +
                secondaryPhoneNumber.slice(6, 9) +
                secondaryPhoneNumber.slice(12, 16);
            new_user = {
                first_name: firstName,
                last_name: lastName,
                phone_number: parsedNumber,
                secondary_phone_number: parsedSecondaryNumber,
                is_active: true,
                staff: false,
                admin: false,
                is_superuser: false,
            };
        }

        try {
            await client('api/users/' + id + '/', {
                method: 'PATCH',
                body: new_user,
            });
            mixpanel.track('Profile: Save User', new_user);
            this.getUser();
        } catch (error) {
            if (Environment !== 'production') {
                console.log(error);
            }
        }
    };

    componentDidMount = async () => {
        // GET request for user data
        // get address, family, and kid id here
        await this.getUser();

        //GET request for family data
        await this.getFamily();

        //GET request for kids data
        await this.getKids();

        //GET request for address data
        await this.getAddresses();

        //GET request for payments data
        await this.getPayments();

        //GET request for profile picture
        await this.getProfilePicture();

        await this.trackPageArrival();
    };

    getUser = async () => {
        try {
            const user = await client('api/users/identity/');
            this.setState({
                userId: user.id,
                user: user,
                firstName: user.first_name,
                lastName: user.last_name,
                email: user.email,
                primaryPhoneNumber: user.phone_number ? this.formatPhoneNumber(user.phone_number) : '',
                secondaryPhoneNumber: user.secondary_phone_number,
            });

            if (this.state.secondaryPhoneNumber !== null) {
                this.setState({
                    secondaryPhoneNumber: this.formatPhoneNumber(user.secondaryPhoneNumber),
                    phoneNumbers: [this.state.primaryPhoneNumber, this.state.secondaryPhoneNumber],
                });
            } else {
                this.setState({
                    phoneNumbers: [this.state.primaryPhoneNumber],
                });
            }
        } catch (error) {
            if (Environment !== 'production') {
                console.log(error);
            }
        }
    };

    formatPhoneNumber(phoneNumber) {
        return phoneNumber
            ? `(${phoneNumber.slice(2, 5)}) ${phoneNumber.slice(5, 8)} - ${phoneNumber.slice(8, 12)}`
            : null;
    }

    getAddresses = async () => {
        try {
            const addresses = await client('api/addresses/');
            const address = addresses.find((x) => x.address_type === 'PRIMARY');
            this.setState({
                address: address,
                street: address?.street,
                city: address?.city,
                state: address?.state,
                zip: address?.zip_code,
            }); // calls render again
        } catch (error) {
            if (Environment !== 'production') {
                console.log(error);
            }
        }
    };

    getFamily = async () => {
        try {
            const families = await client('api/families/');

            this.setState({
                family: families[0],
                addedAt: families[0].added_at,
                bio: families[0].bio,
                familyId: families[0].id,
                primaryUser: families[0].user,
                certificationPreferences: families[0].certification_preferences,
                experiencePreferences: families[0].experience_preferences,
            });
        } catch (error) {
            if (Environment !== 'production') {
                console.log(error);
            }
        }
    };

    getKids = async () => {
        try {
            const kids = await client('api/kids/');
            this.setState({ kids: kids });
            this.kidsIndex = kids.length - 1;
            for (let i = 0; i < kids.length; i++) {
                kids[i].type = kids[i].type === 'CHILD' ? 'Child' : 'Pet';
                kids[i].parsedBirthday =
                    kids[i].birthday.slice(5, 7) +
                    '/' +
                    kids[i].birthday.slice(8, 10) +
                    '/' +
                    kids[i].birthday.slice(0, 4);
            }
        } catch (error) {
            if (Environment !== 'production') {
                console.log(error);
            }
        }
    };

    getPayments = async () => {
        try {
            const apiPayInfo = await client('api/get-payment-setup/');
            this.setState({ payments: apiPayInfo });
        } catch (error) {
            if (Environment !== 'production') {
                console.log(error);
            }
        }
    };

    setDefaultPayment = (id) => {
        this.setState({
            payments: this.state.payments.map((x) => {
                return {
                    ...x,
                    errorMessage: '',
                    isLoading: x.id === id,
                };
            }),
        });
        ApiClient(`api/payment-info/${id}/default/`, { method: 'POST' })
            .then(() => {
                this.setState({
                    payments: this.state.payments.map((x) => {
                        return {
                            ...x,
                            errorMessage: '',
                            isLoading: false,
                            is_default: x.id === id,
                        };
                    }),
                });
                mixpanel.track('Profile: Set Default Payment', { payInfoId: id });
            })
            .catch((error) => {
                this.setState({
                    payments: this.state.payments.map((x) => {
                        return {
                            ...x,
                            errorMessage: x.id === id ? 'An error occurred updating your payment method' : '',
                            isLoading: false,
                        };
                    }),
                });
                mixpanel.track('Profile: Set Default Payment Error', error);
            });
    };

    getProfilePicture = async () => {
        try {
            const profilePic = await client('get-picture/' + this.state.user.id);
            this.setState({ profilePicture: profilePic });
        } catch (error) {
            consoleLogInDev(error);
        }
    };

    /**
     * Temp fix because cannot use normal hook for tracking page landing
     */
    trackPageArrival = async () => {
        try {
            await trackEvent(
                'NAVIGATE_TO',
                'Arrived on page',
                PublicSessionEventType.Page,
                {},
                0,
                0,
                'Profile',
                '/profile/',
            );
        } catch (error) {
            consoleLogInDev(error);
        }
    };

    validate() {
        const { page } = this.state;
        switch (page) {
            case 3:
                const {
                    primaryPhoneNumber,
                    secondaryPhoneNumber,
                    firstName,
                    lastName,
                    email,
                    street,
                    city,
                    zip,
                    state,
                } = this.state;
                if (secondaryPhoneNumber !== null) {
                    this.setState({ errorMessage: 'Please enter your phone number' });
                    let sameNumber = secondaryPhoneNumber !== primaryPhoneNumber;
                    if (!sameNumber) {
                        this.setState({
                            errorMessage: 'Your secondary phone number cannot be the same as your primary number',
                        });
                    }
                    this.setState({
                        isSecondaryPhoneNumber:
                            secondaryPhoneNumber !== '' &&
                            sameNumber &&
                            !/^\s*$/.test(secondaryPhoneNumber) &&
                            this.validatePhoneNumber(secondaryPhoneNumber),
                    });
                } else {
                    this.setState({ isSecondaryPhoneNumber: true });
                }
                this.setState(
                    {
                        isPrimaryPhoneNumber:
                            primaryPhoneNumber !== '' &&
                            !/^\s*$/.test(primaryPhoneNumber) &&
                            this.validatePhoneNumber(primaryPhoneNumber),
                        isFirstName: firstName !== '' && !/^\s*$/.test(firstName),
                        isLastName: lastName !== '' && !/^\s*$/.test(lastName),
                        isEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                            email,
                        ),
                        isStreet: street !== '' && !/^\s*$/.test(street),
                        isCity: city !== '' && !/^\s*$/.test(city),
                        isZip: zip !== '' && /^\d{5}(-\d{4})?$/.test(zip),
                        isState: state !== '',
                    },
                    () => {
                        const {
                            isPrimaryPhoneNumber,
                            isFirstName,
                            isLastName,
                            isEmail,
                            isStreet,
                            isCity,
                            isZip,
                            isState,
                        } = this.state;
                        if (
                            isPrimaryPhoneNumber &&
                            this.state.isSecondaryPhoneNumber &&
                            isFirstName &&
                            isLastName &&
                            isEmail &&
                            isStreet &&
                            isCity &&
                            isZip &&
                            isState
                        ) {
                            this.patchAddress();
                            this.patchUser();
                            this.patchFamily();
                            this.setState({ page: 0 });
                        }
                    },
                );
                return;
            case 4:
                const { bio, kids } = this.state;
                let noBirthdayErrors = true;
                let noNameErrors = true;
                let kids_copy = [...kids];
                this.deleteKids();
                this.setState({ isBio: bio !== '' && !/^\s*$/.test(bio) });
                for (let i = 0; i < kids.length; i++) {
                    let kid = { ...kids_copy[i] };
                    if (kids[i].name === '' || /^\s*$/.test(kids[i].name)) {
                        kid.isName = false;
                        noNameErrors = false;
                    } else {
                        kid.isName = true;
                    }

                    if (kids[i].birthday !== null && kids[i].birthday !== '') {
                        let birthday = kids[i].birthday;
                        let splicedBirthday = birthday.split('-');
                        var now = moment(new Date()).format('YYYY');

                        if (
                            1920 > parseInt(splicedBirthday[0]) ||
                            now < parseInt(splicedBirthday[0]) ||
                            !this.validateDate(kids[i].birthday)
                        ) {
                            kid.isBirthday = false;
                            noBirthdayErrors = false;
                        } else {
                            kid.isBirthday = true;
                        }
                    } else {
                        kid.isBirthday = false;
                        noBirthdayErrors = false;
                    }
                    kids_copy[i] = kid;
                }

                this.setState({ kids: kids_copy });
                this.setState({ isBio: bio !== '' && !/^\s*$/.test(bio) }, () => {
                    const { isBio } = this.state;
                    if (noNameErrors && noBirthdayErrors && isBio) {
                        if (this.state.newKid) {
                            this.postKids();
                            this.patchKids();
                        } else {
                            this.patchKids();
                        }
                        this.patchFamily();
                        this.setState({ page: 1 });
                    }
                });

                return;
            default:
                return;
        }
    }

    tabHandler() {
        const { user, family, address, page, certificationPreferences, experiencePreferences } = this.state;

        switch (page) {
            // Account Display
            case 0:
                return (
                    <AccountDisplay
                        user={user}
                        address={address}
                        edit_account={() => this.edit_account()}
                        primaryPhoneNumber={this.state.primaryPhoneNumber}
                        secondaryPhoneNumber={this.state.secondaryPhoneNumber}
                    />
                );
            // Family Display
            case 1:
                return <FamilyDisplay family={family} kids={this.state.kids} edit_family={() => this.edit_family()} />;
            case 3:
                const {
                    isFirstName,
                    firstName,
                    isLastName,
                    lastName,
                    isPrimaryPhoneNumber,
                    primaryPhoneNumber,
                    isSecondaryPhoneNumber,
                    secondaryPhoneNumber,
                    street,
                    isStreet,
                    city,
                    isCity,
                    state,
                    streetNumber,
                    isState,
                    zip,
                    isZip,
                    errorMessage,
                } = this.state;
                return (
                    <AccountEditDisplay
                        isFirstName={isFirstName}
                        firstName={firstName}
                        isLastName={isLastName}
                        lastName={lastName}
                        isPrimaryPhoneNumber={isPrimaryPhoneNumber}
                        primaryPhoneNumber={primaryPhoneNumber}
                        isSecondaryPhoneNumber={isSecondaryPhoneNumber}
                        secondaryPhoneNumber={secondaryPhoneNumber}
                        street={street}
                        streetNumber={streetNumber}
                        isStreet={isStreet}
                        city={city}
                        isCity={isCity}
                        state={state}
                        isState={isState}
                        zip={zip}
                        isZip={isZip}
                        errorMessage={errorMessage}
                        phoneNumbers={this.state.phoneNumbers}
                        onChangeText={(e, m) => this.onChangeText(e, m)}
                        deleteNumber={() => this.deleteNumber()}
                        gmapsLoaded={this.state.gmapsLoaded}
                        validate={() => this.validate()}
                        stateHandler={(e) => this.setState(e)}
                    />
                );
            // Family Edit Display
            case 4:
                const { isBio, bio, kids, deletedKids } = this.state;
                return (
                    <FamilyEditDisplay
                        isBio={isBio}
                        bio={bio}
                        kids={kids}
                        deletedKids={deletedKids}
                        onChangeText={(e, m) => this.onChangeText(e, m)}
                        deleteKid={(e) => this.deleteKid(e)}
                        setKids={(e) => this.setState(e)}
                        addKidsIndex={() => this.kidsIndex + 1}
                        kidsIndex={this.kidsIndex}
                        validate={() => this.validate()}
                    />
                );
            // Payment Page
            case 6:
                return (
                    <Grid container justify="center">
                        <Grid item sm={6} xs={10}>
                            <PayMethods />
                        </Grid>
                    </Grid>
                );
            // Preference Page
            case 7:
                return (
                    <PreferenceDisplay
                        certificationPreferences={certificationPreferences}
                        experiencePreferences={experiencePreferences}
                        pageHandler={(page) => this.pageHandler(page)}
                        certificates={certificates}
                        experiences={experiences}
                    />
                );
            // Preference Edit Page
            case 8:
                return (
                    <PreferenceEditDisplay
                        certificationPreferences={certificationPreferences}
                        experiencePreferences={experiencePreferences}
                        certificates={certificates}
                        experiences={experiences}
                        setCerts={(e) => this.setState(e)}
                        setExps={(e) => this.setState(e)}
                        patchPreference={(e) => this.patchPreference()}
                    />
                );
            default:
                return;
        }
    }

    render() {
        const { user, primaryUser, page, profilePicture, pictureDialogVisible } = this.state;
        return (
            <Section>
                <ProfileHeader
                    user={user}
                    primaryUser={primaryUser}
                    page={page}
                    refreshProfileImage={this.getProfilePicture}
                    profilePicture={profilePicture}
                    setProfilePicture={(url) => this.setState({ profilePicture: url })}
                    setPictureDialogVisible={(value) => this.setState({ pictureDialogVisible: value })}
                    pictureDialogVisible={pictureDialogVisible}
                    pageHandler={(page) => this.pageHandler(page)}
                />
                {this.tabHandler()}
            </Section>
        );
    }
}

export default withRouter(FamilyProfile);
